import moment from 'moment';
import React from 'react';
import { Header, Message, Modal } from 'semantic-ui-react';

import { clienteApi } from 'src/api';
import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';
import { Contexto } from 'src/contexto';
import { nombreCompletoConNombresPrimero } from 'src/utilidades';

import { IngresoRecuperacion, Props as IngresoProps, Registro } from './IngresoRecuperacion';
import { Props as RegistrosDelDiaProps, RegistrosDelDia } from './RegistrosDelDia';

type State = Readonly<{
    cargandoDatosIniciales: boolean;
    cursos: IngresoProps['cursos'];
    alumnos: IngresoProps['alumnos'];
    cargandoListado: boolean;
    recuperacionesDelDia: RegistrosDelDiaProps['registros'];
    eliminandoRegistro?: string;
}>;

class AgendarRecuperaciones extends React.Component<{}, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public readonly state: State = {
        cargandoDatosIniciales: true,
        cursos: [],
        alumnos: [],
        cargandoListado: true,
        recuperacionesDelDia: [],
    };

    public async componentDidMount() {
        await this.cargarDatosIniciales();
        this.obtenerRegistrosDelDia();
    }

    public render() {
        return (
            <>
                {this.state.eliminandoRegistro && (
                    <ModalEliminacion
                        alCerrar={() => this.setState({ eliminandoRegistro: undefined })}
                        alConfirmar={this.eliminarRegistro}
                    />
                )}

                <Header as='h1'>Agendar recuperaciones</Header>

                <Message info>
                    Las recuperaciones que agende aquí serán visibles en la lista del curso en la
                    fecha elegida.
                </Message>

                <IngresoRecuperacion
                    cargando={this.state.cargandoDatosIniciales}
                    alumnos={this.state.alumnos}
                    cursos={this.state.cursos}
                    fechaInicial={this.fechaActual()}
                    fechaMinima={this.fechaActual()}
                    fechaMaxima={'2020-12-31'}
                    alIngresar={this.agendarRecuperacion}
                />

                <RegistrosDelDia
                    registros={this.state.recuperacionesDelDia}
                    alEliminar={id => this.setState({ eliminandoRegistro: id })}
                />
            </>
        );
    }

    private fechaActual() {
        return moment().format('YYYY-MM-DD');
    }

    private async cargarDatosIniciales() {
        this.setState({ cargandoDatosIniciales: true });

        try {
            const { cursos } = await clienteApi.ejecutar('listaDeCursos');
            const pAlumnos = clienteApi.ejecutar('listaDeAlumnos');

            this.setState({
                cursos: cursos.sort(
                    (a, b) =>
                        a.dia - b.dia ||
                        a.bloqueHorario.horaInicio.localeCompare(b.bloqueHorario.horaInicio) ||
                        a.id - b.id,
                ),
            });

            const { alumnos } = await pAlumnos;

            this.setState({
                alumnos: alumnos
                    .map(a => ({ ...a, nombre: nombreCompletoConNombresPrimero(a.nombre) }))
                    .sort((a, b) => a.nombre.localeCompare(b.nombre)),
            });
        } catch (error) {
            this.context.mostrarModalError(error);
        } finally {
            this.setState({ cargandoDatosIniciales: false });
        }
    }

    private readonly agendarRecuperacion = async (datos: Registro) => {
        try {
            await clienteApi.ejecutar('agendarRecuperacion', datos);
            this.obtenerRegistrosDelDia();
            return true;
        } catch (error) {
            this.context.mostrarModalError(error);
            return false;
        }
    };

    private readonly eliminarRegistro = () => {
        if (!this.state.eliminandoRegistro) return;

        clienteApi
            .ejecutar('eliminarRecuperacionAgendada', { idRegistro: this.state.eliminandoRegistro })
            .then(() => this.obtenerRegistrosDelDia())
            .catch(this.context.mostrarModalError);
    };

    private obtenerRegistrosDelDia() {
        this.setState({ cargandoListado: true });
        clienteApi
            .ejecutar('recuperacionesAgendadasHoy')
            .then(recuperacionesDelDia => {
                this.setState({ cargandoListado: false, recuperacionesDelDia });
            })
            .catch(error => {
                this.setState({ cargandoListado: false });
                this.context.mostrarModalError(error);
            });
    }
}

const ModalEliminacion = (props: { alConfirmar(): void; alCerrar(): void }) => (
    <ModalEnfocable open closeIcon onClose={props.alCerrar}>
        <Modal.Header content='¿Está seguro que quiere eliminar este registro?' />
        <Modal.Content content='Esta acción no se puede deshacer' />
        <Modal.Actions
            actions={[
                { key: 'no', content: 'No', onClick: props.alCerrar },
                {
                    key: 'si',
                    content: 'Sí',
                    negative: true,
                    onClick: () => {
                        props.alConfirmar();
                        props.alCerrar();
                    },
                },
            ]}
        />
    </ModalEnfocable>
);

export default AgendarRecuperaciones;



// WEBPACK FOOTER //
// ./src/modulos/Recuperaciones/AgendarRecuperaciones.tsx